import { HttpClient, HttpResponse } from '@angular/common/http';
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, SecurityContext } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ImageViewerInput } from 'src/app/shared/model/image-vewer-input';
import { RestService } from 'src/app/shared/service/rest.service';
import { HttpMethod } from '../../model/http-method';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';

@Component({
  selector: 'app-image-viewer-dialog',
  templateUrl: './image-viewer-dialog.component.html',
  styleUrls: ['./image-viewer-dialog.component.scss']
})
export class ImageViewerDialogComponent extends RestService implements AfterViewInit {

  displaingImage: number = 0;
  showInfo: boolean;
  errorDownload: boolean;
  rotate = 0;
  img: HTMLImageElement;


  constructor(public dialogRef: MatDialogRef<InfoDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ImageViewerInput,
    public translate: TranslateService, protected http: HttpClient, private sanitizer: DomSanitizer, private ref: ChangeDetectorRef) {
    super(http);
  }

  ngAfterViewInit(): void {
    this.img = document.getElementById('imageViewContentImage') as HTMLImageElement;
    this.displayImage(0);
  }


  createSource(httpMethod: HttpMethod, imageNumber: number): Observable<HttpResponse<Blob>> {
    if (httpMethod === HttpMethod.GET) {
      return this.doGetBlob(this.data.imageSourceAndDescription[imageNumber].link);
    } else if (httpMethod === HttpMethod.POST) {
      console.error('Not implemented for method: ', httpMethod);
    } else {
      console.error('INVALID method: ', httpMethod);
    }
  }

  displayImage(imageNumber: number, rotate: number = 0): void {
    const choosenMethod = this.data.method;
    this.createSource(choosenMethod, imageNumber).subscribe(rs => {
      const blobUrl = URL.createObjectURL(rs.body);
      const saveUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
      this.img.src = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, saveUrl);
      this.img.style.transform = `rotate(${rotate}deg)`;
      this.errorDownload = false;
    }, err => {
      console.error(err);
      this.errorDownload = true;
    });
  }


  handleDisplayNext(): void {
    this.rotate = 0;
    this.displaingImage = this.displaingImage < this.data.imageSourceAndDescription.length - 1 ? this.displaingImage + 1 : 0;
    this.displayImage(this.displaingImage);
  }

  handleDisplayPrevious(): void {
    this.rotate = 0;
    this.displaingImage = this.displaingImage > 0 ? this.displaingImage - 1 : this.data.imageSourceAndDescription.length - 1;
    this.displayImage(this.displaingImage);
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'ArrowRight') {
      this.handleDisplayNext();
    } else if (event.key === 'ArrowLeft') {
      this.handleDisplayPrevious();
    } else if (event.key === 'i' && this.data.imageSourceAndDescription[this.displaingImage]?.description?.size > 0) {
      this.handleInfo();
    }
  }

  handleClose(): void {
    this.dialogRef.close();
  }

  handleInfo(): void {
    this.showInfo = !this.showInfo;
  }

  handleRotate(): void {
    this.rotate += 90;
    this.displayImage(this.displaingImage, this.rotate);
  }

}
